import React from 'react';
import { Select, MenuItem } from '@mui/material';
import { useTranslate } from 'react-admin';
import useVenues from '../hooks/useVenues';

const VenueFilterInput = (props) => {
  const translate = useTranslate();
  const venues = useVenues();

  return (
    <Select
      variant="outlined"
      size="small"
      value={props.item.value || ''}
      onChange={(event) => props.applyValue({ ...props.item, value: event.target.value })}
      displayEmpty
      style={{ width: '100%' }}
    >
      <MenuItem value="" disabled>
        {translate('filters.select_venue', { _: 'Select venue' })}
      </MenuItem>
      {venues.map((venue) => (
        <MenuItem key={venue.id} value={venue.id}>
          {venue.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default VenueFilterInput;
